import WebAPI from './WebAPI'

const API_V2_ROOT = process.env.API_V2_ROOT
const API_FOR_XANDR = process.env.API_ROOT_XANDR_NODE
const LONG_RUNNING_XANDR_API = process.env.API_LOAD_BALANCER

class LongRunningXandrAPI extends WebAPI {
  constructor() {
    super({ baseURL: LONG_RUNNING_XANDR_API })
  }

  getQueryCount({ targetDefinition, type, user, caeId }) {
    // timeout is 12 minutes
    return this.__post({
      extensionURL: '/xandr/targetDefinitionQueryCount',
      payload: { targetDefinition, user, type, caeId },
      config: { timeout: 60 * 12 * 1000 },
    })
  }
}

class XandrConfigAPI extends WebAPI {
  constructor() {
    super({ baseURL: API_V2_ROOT })
  }

  getConfig(traitType) {
    return this.__get({ extensionURL: `/Datasets/Digital/${traitType}` }).then(resp => resp.data)
  }

  getPrimaryInsightsConfig() {
    return this.__get({ extensionURL: `/SSM/Parameter/Config` }).then(resp => resp.data.primaryInsights)
  }

  getDatasourcesConfig() {
    return this.__get({ extensionURL: `/SSM/Datasources/Config` }).then(resp => resp.data)
  }
}

/**
 * Look at the Confluence API article for more information
 * https://audiencematters.atlassian.net/wiki/spaces/AM/pages/448135169/Revision+History
 */
class XandrAPI extends WebAPI {
  constructor() {
    super({ baseURL: API_FOR_XANDR })
    this.long = new LongRunningXandrAPI()
    this.config = new XandrConfigAPI()
  }

  getTraits(type) {
    return this.__get({ extensionURL: `/Xandr/Traits${type ? `?type=${type}` : ''}` }).then(resp => resp.data)
  }

  getTrait(id, type) {
    return this.__get({ extensionURL: `/Xandr/Trait/${id}${type ? `?type=${type}` : ''}` }).then(resp => resp.data)
  }

  getSegments(type) {
    return this.__get({ extensionURL: `/Xandr/Segments${type ? `?type=${type}` : ''}` }).then(resp => resp.data)
  }

  getSegment(id, type) {
    return this.__get({ extensionURL: `/Xandr/Segment/${id}${type ? `?type=${type}` : ''}` }).then(resp => resp.data)
  }

  getCampaigns(type, filterByExportEndDate = false) {
    type = type || 'advertising' // default to advertising
    return this.__get({ extensionURL: `/Xandr/Campaign${type ? `?type=${type}` : ''}` })
      .then(resp => resp.data)
      .then(d => {
        if (filterByExportEndDate) {
          let filteredList = []
          let filterOutlist = []
          let todaysDate = new Date()
          for (let c of d) {
            if (c.exportSchedule) {
              if (todaysDate < new Date(c.exportSchedule.exportEndDate)) {
                filteredList.push(c)
              }
            } else {
              filterOutlist.push(c)
            }
          }
          // if you need to sort the filtered list
          // filteredList.sort((a, b) => {
          //   let ad = new Date(a.exportSchedule.exportEndDate)
          //   let bd = new Date(b.exportSchedule.exportEndDate)
          //   if (ad < bd) {
          //     return -1
          //   } else if (ad > bd) {
          //     return 1
          //   } else {
          //     0
          //   }
          // })
          return filteredList
        }
        return d
      })
  }

  getCampaign(id, type) {
    type = type || 'advertising' // default to advertising
    return this.__get({ extensionURL: `/Xandr/Campaign/${id}${type ? `?type=${type}` : ''}` }).then(resp => resp.data)
  }

  getDestinations(type) {
    return this.__get({ extensionURL: `/Xandr/Destinations${type ? `?type=${type}` : ''}` }).then(resp => resp.data)
  }

  getDestinationsConfig() {
    return this.__get({ extensionURL: `/Xandr/Destinations/Config` }).then(resp => resp.data)
  }

  getPrimaryInsightsConfig() {
    return this.config.getPrimaryInsightsConfig()
  }

  getDatasourcesConfig() {
    return this.config.getDatasourcesConfig()
  }

  getContext(type) {
    return this.__get({ extensionURL: `/Xandr/Context${type ? `?type=${type}` : ''}` }).then(resp => resp.data)
  }

  getXandrTracing(d, id) {
    let idString = id ? `&id=${id}` : ''
    return this.__get({ extensionURL: `/Xandr/Tracing?date=${d.getTime()}${idString}` }).then(d => d.data)
  }

  getTopLevelTracing(d) {
    return this.__get({ extensionURL: `/Xandr/Tracing/Top?date=${d.getTime()}` }).then(d => d.data)
  }

  getQueryCount({ targetDefinition, type, user, caeId }) {
    return this.long.getQueryCount({ targetDefinition, type, user, caeId })
  }

  getSegmentationTraits(path) {
    return this.config.getConfig(path)
  }

  // assumes all things are saved in Audience Matters
  sendDownStream({ targetId, user, type }) {
    return this.__post({ extensionURL: '/Xandr/Downstream', payload: { target: { targetId }, user, type } })
    // return fetchSingleTarget({target_id: targetId}).then(resp => {
    //   let t = resp.data
    //   t.activation_status = 'SUBMITTED'
    //   return t
    // })
  }

  getXanderTargetList() {
    return this.__get({
      extensionURL: '/Xandr/TargetList',
    })
  }

  modelLAL({ target }) {
    return this.__post({
      extensionURL: '/Xandr/ModelLAL',
      payload: { target },
    })
  }

  getVideoAmpAudienceList() {
    return this.__get({ extensionURL: `/Xandr/GetVideoAmpAudiencesList` }).then(resp => resp.data)
  }

  requestVideoAmpAudienceIntake(id, type) {
    type = type || 'advertising' // default to advertising
    return this.__post({
      extensionURL: `/Xandr/RequestVideoAmpAudienceIntake?id=${id}${type ? `&type=${type}` : ''}`,
    })
  }

  retargetingRequest({ placementId, requestName, startDate, endDate, type }) {
    type = type || 'advertising' // default to advertising
    return this.__post({
      extensionURL: `/Xandr/RequestRetargetingAudience${type ? `?type=${type}` : ''}`,
      payload: { placementId, requestName, startDate, endDate },
    })
  }
}

export default new XandrAPI()



// WEBPACK FOOTER //
// ./src/app/api/XandrAPI.js